var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96969 1.53897L8.49969 4.06897L3.53069 9.03897C3.39227 9.17746 3.22009 9.27742 3.03119 9.32897L0.47319 10.0265C0.409435 10.0438 0.342242 10.0439 0.278411 10.0269C0.21458 10.0099 0.156377 9.97631 0.109691 9.92958C0.063005 9.88284 0.0294935 9.8246 0.0125479 9.76075C-0.00439775 9.6969 -0.00417618 9.62971 0.0131902 9.56597L0.71069 7.00797C0.76224 6.81907 0.862201 6.6469 1.00069 6.50847L5.96869 1.53897H5.96969ZM9.51469 0.523972C9.85018 0.859473 10.0387 1.31451 10.0387 1.78897C10.0387 2.26344 9.85018 2.71847 9.51469 3.05397L9.02969 3.53897L6.49969 1.00897L6.98469 0.523972C7.32019 0.188478 7.77522 0 8.24969 0C8.72416 0 9.17919 0.188478 9.51469 0.523972Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.bc9d5d7412e531b8e8942d840215f407.svg";
export { ForwardRef as ReactComponent };